import globals from '../assets/styles/globals.scss'
import moment from 'moment'

export const getColorNameFromStatus = program => {
  switch (program?.status) {
    case 'completed':
      return 'green'
    case 'active':
      return moment(program.startDate).isAfter(moment(), 'day') ? 'gray' : 'blue'
    default:
      return 'gray'
  }
}

export const colorNameToData = {
  green: {
    header: {
      color: globals.veryDarkTeal,
    },
    banner: {
      color: globals.darkTeal,
      backgroundColor: globals.lighterTeal,
      text: () => ({ tKey: 'programs.programDashboard.banner.complete', values: {} }),
    },
  },
  blue: {
    header: {
      color: globals.darkerBlue,
    },
    banner: {
      color: globals.darkBlue,
      backgroundColor: globals.lighterBlue,
      text: (program) => ({
        tKey: 'programs.programDashboard.banner.active',
        values: { days: moment(program.endDate).diff(moment(), 'days') },
      }),
    },
  },
  gray: {
    header: {
      color: globals.darkerNavy,
    },
    banner: {
      color: globals.slateGray,
      backgroundColor: globals.lightGray,
      text: (program) => {
        if (program.status === 'future') {
          return {
            tKey: 'programs.programDashboard.banner.registrationOpens',
            values: { days: moment(program.registrationStartsAt).diff(moment(), 'days') },
          }
        }

        return {
          tKey: 'programs.programDashboard.banner.starts',
          values: { days: moment(program.startDate).diff(moment(), 'days') },
        }
      },
    },
  },
}
